<template>
  <Layout :meta="dataMeta">
   <div class="detail_jurusan">
      <div
      class="detail_jurusan_background kingster-page-title-wrap  kingster-style-custom kingster-left-align"
      :style="{
        background: 'url(' + jurusanDetail.image + ')',
      }"
      style="background-size: cover !important; background-repeat: no-repeat !important;"
    >
      <div class="kingster-header-transparent-substitute"></div>
      <div class="kingster-page-title-overlay"></div>
      <div class="kingster-page-title-bottom-gradient"></div>
      <div class="kingster-page-title-container kingster-container">
        <div
          class="kingster-page-title-content kingster-item-pdlr"
          style="padding-top: 390px ;padding-bottom: 55px ;"
        >
          <div
            class="kingster-page-caption"
            style="font-size: 21px ;font-weight: 400 ;letter-spacing: 0px ;"
          >
            {{ dataMeta.name }}
          </div>
          <h1
            class="kingster-page-title"
            style="font-size: 48px ;font-weight: 700 ;text-transform: none ;letter-spacing: 0px ;"
          >
            {{ jurusanDetail.title }}
          </h1>
        </div>
      </div>
    </div>
    <div class="kingster-breadcrumbs">
      <div class="kingster-breadcrumbs-container kingster-container">
        <div class="kingster-breadcrumbs-item kingster-item-pdlr">
          <span property="itemListElement" typeof="ListItem"
            ><a
              property="item"
              typeof="WebPage"
              title="Go to Kingster."
              href="/"
              class="home"
              ><span property="name">Home</span></a
            >
            <dataMeta property="position" content="1" /> </span
          >&gt;<span property="itemListElement" typeof="ListItem">
            <a
              property="item"
              typeof="WebPage"
              title="Go to Bachelor Of Science in Business Administration."
              :href="`/jurusan-detail/${$route.params.id}`"
              class="post post-page"
              ><span property="name">{{ jurusanDetail.title }}</span></a
            >
          </span>
        </div>
      </div>
    </div>
    <div class="kingster-page-wrapper" id="kingster-page-wrapper">
      <div class="gdlr-core-page-builder-body">
        <div
          class="gdlr-core-pbf-sidebar-wrapper "
          style="margin: 0px 0px 60px 0px;"
        >
          <div
            class="gdlr-core-pbf-sidebar-container gdlr-core-line-height-0 clearfix gdlr-core-js gdlr-core-container"
          >
            <div
              class="gdlr-core-pbf-sidebar-content  gdlr-core-column-40 gdlr-core-pbf-sidebar-padding gdlr-core-line-height gdlr-core-column-extend-left"
              style="padding: 30px 0px 30px 0px;"
            >
              <div class="gdlr-core-pbf-sidebar-content-inner">
                <div
                  class="gdlr-core-pbf-element"
                  data-aos="fade-in"
                  :data-aos-duration="`1000`"
                  :data-aos-delay="`100`"
                >
                  <div
                    class="gdlr-core-image-item gdlr-core-item-pdlr gdlr-core-item-pdb  gdlr-core-center-align"
                    style="padding-bottom: 40px ;"
                  >
                    <div
                      class="gdlr-core-image-item-wrap gdlr-core-media-image  gdlr-core-image-item-style-rectangle"
                      style="border-width: 0px;"
                    >
                      <img
                        :src="
                          jurusanDetail.image != null
                            ? jurusanDetail.image
                            : require('@/assets/images/template4/shutterstock_447921760-800x292.jpg')
                        "
                        style="object-fit: cover;"
                        width="1000"
                        height="400"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
                <div
                  class="gdlr-core-pbf-element"
                  data-aos="fade-in"
                  :data-aos-duration="`2000`"
                  :data-aos-delay="`100`"
                >
                  <div
                    class="gdlr-core-title-item gdlr-core-item-pdb clearfix  gdlr-core-left-align gdlr-core-title-item-caption-top gdlr-core-item-pdlr"
                  >
                    <div class="gdlr-core-title-item-title-wrap clearfix">
                      <h3
                        class="gdlr-core-title-item-title gdlr-core-skin-title "
                        style="font-size: 24px ;font-weight: 700 ;letter-spacing: 0px ;text-transform: none ;color: #293a5b ;"
                      >
                        {{ jurusanDetail.title }}
                      </h3>
                    </div>
                  </div>
                </div>
                <div class="gdlr-core-pbf-element">
                  <div
                    class="gdlr-core-text-box-item gdlr-core-item-pdlr gdlr-core-item-pdb gdlr-core-left-align"
                    style="padding-bottom: 10px ;"
                  >
                    <div
                      class="gdlr-core-text-box-item-content"
                      style="font-size: 19px ;font-weight: 600 ;letter-spacing: 0px ;text-transform: none ;"
                      v-html="jurusanDetail.body"
                    ></div>
                  </div>
                </div>
                <div class="gdlr-core-pbf-element">
                  <div
                    class="gdlr-core-text-box-item gdlr-core-item-pdlr gdlr-core-item-pdb gdlr-core-left-align"
                    style="padding-bottom: 15px ;"
                  >
                    <div
                      class="gdlr-core-text-box-item-content"
                      style="font-size: 21px ;text-transform: none ;color: #3db166 ;"
                    >
                      <p>
                        If you&#8217;re an educational professional who are
                        looking to progress into management and consultancy, or
                        an educational planning or development role, this is the
                        best degree for you.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="gdlr-core-pbf-sidebar-right gdlr-core-column-extend-right  kingster-sidebar-area gdlr-core-column-20 gdlr-core-pbf-sidebar-padding  gdlr-core-line-height"
              style="padding: 35px 0px 30px 0px;"
            >
              <div class="gdlr-core-sidebar-item gdlr-core-item-pdlr">
                <div id="text-18" class="widget widget_text kingster-widget">
                  <div class="textwidget">
                    <div
                      class="gdlr-core-widget-box-shortcode "
                      style="color: #ffffff ;padding: 30px 45px;background-color: #192f59 ;"
                    >
                      <div
                        class="gdlr-core-widget-box-shortcode-content"
                        data-aos="zoom-in"
                        :data-aos-duration="`1000`"
                        :data-aos-delay="`100`"
                      >
                        <p></p>
                        <h3
                          style="font-size: 20px; color: #fff; margin-bottom: 25px;"
                        >
                          Informasi Kontak
                        </h3>
                        <p>
                          <span
                            style="color: #3db166; font-size: 16px; font-weight: 600;"
                            >{{ dataMeta.name }}</span
                          >
                          <br />
                          <span style="font-size: 15px;"
                            ><br />
                            {{ dataMeta.address }}<br />
                            {{ dataMeta.sub_district }},{{ dataMeta.city }}.
                            {{ dataMeta.province }}</span
                          >
                        </p>
                        <p>
                          <span style="font-size: 15px;"
                            >{{ dataMeta.phone }}<br />
                            {{ dataMeta.email }}<br />
                          </span>
                        </p>
                        <p>
                          <span style="font-size: 16px; color: #3db166;"
                            >Senin – Jumat 8:00 Pagi – 5:00 Sore</span
                          >
                        </p>
                        <span
                          class="gdlr-core-space-shortcode"
                          style="margin-top: 40px ;"
                        ></span>
                        <h3
                          style="font-size: 20px; color: #fff; margin-bottom: 15px;"
                        >
                          Sosial Media
                        </h3>
                        <div
                          class="gdlr-core-social-network-item gdlr-core-item-pdb  gdlr-core-none-align"
                          style="padding-bottom: 0px ;"
                        >
                          <a
                            v-if="contact && contact.facebook"
                            :href="contact.facebook.body"
                            target="_blank"
                            class="gdlr-core-social-network-icon"
                            title="facebook"
                            style="color: #3db166 ;"
                            ><i class="fa fa-facebook"></i></a
                          ><a
                            v-if="contact && contact.linkedin"
                            :href="contact.linkedin.body"
                            target="_blank"
                            class="gdlr-core-social-network-icon"
                            title="linkedin"
                            style="color: #3db166 ;"
                            ><i class="fa fa-linkedin"></i></a
                          ><a
                            v-if="contact && contact.twitter"
                            :href="contact.twitter.body"
                            target="_blank"
                            class="gdlr-core-social-network-icon"
                            title="twitter"
                            style="color: #3db166 ;"
                            ><i class="fa fa-twitter"></i></a
                          ><a
                            v-if="contact && contact.instagram"
                            :href="contact.instagram.body"
                            target="_blank"
                            class="gdlr-core-social-network-icon"
                            title="instagram"
                            style="color: #3db166 ;"
                            ><i class="fa fa-instagram"></i
                          ></a>
                          <a
                            v-if="contact && contact.youtube"
                            :href="contact.youtube.body"
                            target="_blank"
                            class="gdlr-core-social-network-icon"
                            title="youtube"
                            style="color: #3db166 ;"
                            ><i class="fa fa-youtube"></i
                          ></a>
                        </div>
                        <span
                          class="gdlr-core-space-shortcode"
                          style="margin-top: 40px ;"
                        ></span>
                        <!-- <a
                          class="gdlr-core-button gdlr-core-button-shortcode  gdlr-core-button-gradient gdlr-core-button-no-border"
                          href="#"
                          style="padding: 16px 27px 18px;margin-right: 20px;border-radius: 2px;-moz-border-radius: 2px;-webkit-border-radius: 2px;"
                          ><span class="gdlr-core-content"
                            >Student Resources</span
                          ></a
                        > -->
                        <p></p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
   </div>
  </Layout>
</template>
<script>
import broker from "@/utils/broker";

export default {
  props: ["dataMeta"],
  data() {
    return {
      jurusanDetail: {},
      contact: {
        facebook: {},
        twitter: {},
        instagram: {},
        linkedin: {},
        youtube: {},
      },
    };
  },
  dataMetaInfo() {
    return {
      title: `${this.dataMeta.name} - Detail Jurusan`,
      htmlAttrs: {
        lang: "en",
        amp: true,
      },
    };
  },
  async mounted() {
    await this.getDataJurusanDetail();
    await this.getSosialMedia();
    console.log(`--meta`, meta);
  },
  methods: {
    async getDataJurusanDetail() {
      let url = this.$route.params.id;
      broker.fetch.get(`/webschool/content/${url}`).then((res) => {
        this.jurusanDetail = res.data.data;
      });
    },
    async getSosialMedia() {
      await broker.fetch
        .get(
          `/webschool/content?types[]=footer_desc&types[]=social_youtube&types[]=social_facebook&types[]=social_instagram&types[]=social_twitter&types[]=social_linkedin&status=published`
        )
        .then((res) => {
          const data = res.data.data;

          this.contact.facebook = data.find(
            (o) => o.type.name === "social_facebook"
          );
          this.contact.instagram = data.find(
            (o) => o.type.name === "social_instagram"
          );
          this.contact.twitter = data.find(
            (o) => o.type.name === "social_twitter"
          );
          this.contact.linkedin = data.find(
            (o) => o.type.name === "social_linkedin"
          );
          this.contact.youtube = data.find(
            (o) => o.type.name === "social_youtube"
          );
        });
    },
  },
  components: {
    Layout: () => import("@/components/template4/Layout"),
  },
};
</script>
<style lang="css">
.detail_jurusan .detail_jurusan_background {
  background-size: cover !important;
  background-repeat: no-repeat;
}
@import "../../../../assets/css/template4/style-core.css";
@import "../../../../assets/css/template4/kingster-style-custom.css";
@import "../../../../assets/css/template4/page-builder.css";
@import "../../../../assets/css/template4/style.css";
</style>
